export default __webpack_public_path__ + "static/media/gl.afe39827.svg";